import { FC, Fragment } from 'react';
import { HEADLINE_BOLD_RE } from './headlineHighlight';

type Props = {
  snippet: string;
  className?: string;
};

/**
 * Безопасный рендер фрагмента `matchedPhraseSnippet`/`matchedCommentSnippet` от
 * `ts_headline('russian', …)`. Сервер выводит подсветку только в виде `<b>…</b>`;
 * парсим строку и рендерим `<mark>` вместо dangerouslySetInnerHTML.
 *
 * Только для значений с подсветкой: сырой текст через этот парсер пропускать нельзя —
 * литеральные `<b>`/`</b>` из текста он съест, приняв за разметку.
 */
export const ContentSnippet: FC<Props> = ({ snippet, className }) => {
  const parts: { text: string; highlighted: boolean }[] = [];
  let lastIndex = 0;
  for (const match of snippet.matchAll(HEADLINE_BOLD_RE)) {
    const matchIndex = match.index ?? 0;
    if (matchIndex > lastIndex) {
      parts.push({ text: snippet.slice(lastIndex, matchIndex), highlighted: false });
    }
    parts.push({ text: match[1], highlighted: true });
    lastIndex = matchIndex + match[0].length;
  }
  if (lastIndex < snippet.length) {
    parts.push({ text: snippet.slice(lastIndex), highlighted: false });
  }

  return (
    <span className={className}>
      {parts.map((part, index) => (
        <Fragment key={index}>
          {part.highlighted ? <mark className="bg-primary/20 text-foreground rounded-sm px-0.5">{part.text}</mark> : part.text}
        </Fragment>
      ))}
    </span>
  );
};
